import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
    },
    initialComments: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    metadata: {
      width: '50%',
      marginTop: theme.spacing(3),
    },
    reviewingPhysicianContainer: {
      width: '25%',
      marginTop: theme.spacing(3),
      textAlign: 'right'
    },
    reviewingPhysician: {
      width: 'auto !important',
    },
    normality: {
      marginTop: theme.spacing(2),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 220,
    },
    red: {
      color: red.A700,
    },
    abnormal: {
      color: red.A400,
    },
    critical: {
      color: red.A700,
    },
    closingComment: {
      width: '50% !important',
      marginTop: theme.spacing(2) + 'px !important',
      marginBottom: theme.spacing(4) + 'px !important',
    },
    closingContainer: {
      float: 'right',
    },
    contactContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    buttonsContainer: {
      marginBottom: theme.spacing(16),
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    error: {
      color: red.A400,
    },
  }),
);

export default useStyles;